import { render, staticRenderFns } from "./sky.global.vue?vue&type=template&id=24e669fa&"
import script from "./sky.global.vue?vue&type=script&lang=js&"
export * from "./sky.global.vue?vue&type=script&lang=js&"
import style0 from "./sky.global.vue?vue&type=style&index=0&id=24e669fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports